<template>
  <q-popup-proxy ref="popupProxy">
    <q-banner>
      <p class="accept__title">{{ this.title || 'Подтвердите действие' }}</p>
      <div class="accept__actions">
        <CustomButton
          outlined
          :disabled="!!this.loading || this.localLoading"
          @click="this.close()"
          :height="40"
          >Отмена</CustomButton
        >
        <CustomButton
          :loading="!!this.loading || this.localLoading"
          :disabled="!!this.loading || this.localLoading"
          :color="color || 'primary-light'"
          @click="this.onClick()"
          :height="40"
          >{{submitBtnText || 'Подтвердить'}}</CustomButton
        >
      </div>
    </q-banner>
  </q-popup-proxy>
</template>

<script>
import CustomButton from "@/components/common/CustomButton.vue";

export default {
  name: "PopupConfirm",
  props: ["closePopup", "approve", "loading", "title", 'color', 'submitBtnText'],
  components: {CustomButton},
  data() {
    return {
      localLoading: false
    }
  },
  methods: {
    async onClick() {
      if(!this.approve) return
      this.localLoading = true
      await this.approve()
      this.localLoading = false
      this.close()
    },
    close() {
      try {
        this.$refs.popupProxy.hide();
        this.closePopup && this.closePopup()
      } catch (e) {}
    }
  }
}
</script>

<style scoped lang="scss">
.accept {
  &__title {
    font-size: 16px;
    font-weight: 600;
    max-width: 300px;
    margin-bottom: 0;
  }

  &__actions {
    display: flex;
    align-content: center;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 15px;
  }
}
</style>
